import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {GlobalEventsManager} from "./_services/globaleventsmanager.service";

import { AppSettings } from './_models/settings.models'

declare var jQuery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  @ViewChild('staticModalError') staticModalError;

  ruta: string;
  //menu : boolean = true;
  showNavBar: boolean = true;
  menuextendido: boolean = true;
  mostrarError: boolean = false;
  objError: any = [];
  breadcrumb: string = "";

  alert: any = {
    "texto" : "Alert",
    "mostrar": true
  };

  entorno :string = "";

  constructor(private router:Router,
              private activatedRoute: ActivatedRoute,
              private globalEventsManager: GlobalEventsManager){
    //console.log(router);
    //this.ruta = activatedRoute.snapshot.url[0].path;

    //console.log = function() {}; //línea para quitar los console.log

    this.entorno = AppSettings.ENTORNO;

    //console.log(this.ruta);
    this.globalEventsManager.showNavBarEmitter.subscribe((mode)=>{
            // mode will be null the first time it is created, so you need to igonore it when null
            if (mode !== null) {
              this.showNavBar = mode;
            }
        });

    this.globalEventsManager.menuExtendidoEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.menuextendido = mode;

            }
        });

    this.globalEventsManager.mostrarErrorEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.mostrarError = mode;
              if (this.mostrarError){
                this.staticModalError.show();
              }
            }
        });

    this.globalEventsManager.objErrorEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.objError = mode;
            }
        });

    this.globalEventsManager.nombrePaginaEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.breadcrumb = mode;
            }
        });

    this.globalEventsManager.alertEmitter.subscribe((mode)=>{

            if (mode !== null) {
              this.alert = mode;
              if (this.alert.mostrar){
                this.mostrarAlert();
              }
            }
        });

    let alerta: any = {
      "texto" : "",
      "mostrar": false
    };
    this.globalEventsManager.setAlert(alerta);

  }

  cerrarError(){
    this.globalEventsManager.objError([]);
    this.globalEventsManager.mostrarError(false);
    this.staticModalError.hide();
  }

  ocultarAlert(){
    jQuery("#alerta").css("opacity","0");
    this.alert.mostrar = false;
  }

  mostrarAlert(){
    jQuery("#alerta").css("opacity","1");
    setTimeout(() => this.ocultarAlert(), 2000);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts